import { Room } from '@webrtc/lib/Room'
import type { ID } from '@webrtc/lib/identifier'

import { MuteButton } from './MuteButton'
import { ShareButton } from './ShareButton'
import { VideoButton } from './VideoButton'
import { FC } from 'react'

export const Buttons: FC<ButtonsProps> = ({
  id,
  media,
  waitingMedia,
  room,
  showWaiting,
  setShowWaiting,
  children,
}) => {
  return (
    <div className="absolute bottom-0 left-0 flex flex-col justify-between p-8 space-y-4 md:p-16">
      <ShareButton id={id} />
      {!media ? null : <MuteButton media={media} />}
      {!waitingMedia || !media || !room ? null : (
        <VideoButton
          media={media}
          waitingMedia={waitingMedia}
          room={room}
          showWaiting={showWaiting}
          setShowWaiting={setShowWaiting}
        />
      )}
      {children}
    </div>
  )
}

interface ButtonsProps {
  id: ID
  media: MediaStream | null
  waitingMedia: MediaStream | null
  room: Room | null
  showWaiting: boolean
  setShowWaiting: (b: boolean) => void
}
